import React from "react";
import { useTargetConstants } from "Hooks/target/useTargetConstants";
import { useFormContext } from "react-hook-form";
import CreateEditModal from "Modules/Checkins/CreateEditModal";
import { useCheckin } from "Hooks/checkin/useCheckin";
import { get } from "lodash";
import {  useSetRecoilState } from "recoil";
import { displayLinkState } from "Recoil/Checkins/atom";

const CheckinAction = ({ name }) => {
  const { checkinMapping } = useTargetConstants();
  const { watch, setValue, clearErrors, trigger, methods } = useFormContext();
  const { addEditCheckinTemplate } = useCheckin(name, methods);
  const { assignPeople } = watch();
  const watchCheckinData = watch(name);
  const current = watch(`${name}.current`);

  const setDisplayLinkState = useSetRecoilState(displayLinkState);

  const handleClose = () => {
    clearErrors(name);
    setValue(name, { ...checkinMapping() });
    setDisplayLinkState({});
  };

  const saveCheckin = async () => {
    const isValid = await trigger(name);
    if (isValid) {
      addEditCheckinTemplate(watchCheckinData);
      handleClose();
    }
  };
  return get(current, "checkinModal") ? (
    <CreateEditModal
      name={name}
      targetUsers={assignPeople}
      saveCheckin={saveCheckin}
      handleClose={handleClose}
      isTemplate={true}
    />
  ) : null;
};

export default CheckinAction;
